module.exports = __webpack_public_path__ + "static/media/weapon.5d72cd12.png";